<script>
  import Header from "../components/Common/Header.svelte";
  import SectorPreviewGrid from "../components/Sectors/SectorPreviewGrid.svelte";
  const sectors = WP.sectorIdMap;
</script>

<Header>
  <h1>Sectors</h1>
  <p>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua.
  </p>
</Header>

<hr id="sectors-home-separator" />
<div class="container">
  <SectorPreviewGrid {sectors} />
</div>

<style>
  #sectors-home-separator {
    height: 2px;
    background: #ebe9e9;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
  }
</style>
